import axios from 'axios';
import qs from 'qs';

export const getConnectionQuizById = ({
  lessonId,
  locale,
}: {
  lessonId: string;
  locale?: string;
}) =>
  axios.get(
    `/api/v1/connection-quizzes/${lessonId}${locale ? `?${qs.stringify({ locale })}` : ''}`,
  );

export const createConnectionQuiz = (data: any) =>
  axios.post('/api/v1/connection-quizzes', data);

export const updateConnectionQuizById = ({
  lessonId,
  data,
}: {
  lessonId: string;
  data: any;
}) => axios.put(`/api/v1/connection-quizzes/${lessonId}`, data);

export const removeConnectionQuizById = (quizId: string) =>
  axios.delete(`/api/v1/connection-quizzes/${quizId}`);
